module.exports = __webpack_public_path__ + "img/resize-icon-mb.4d2a430e.svg";